import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ab7d175")

_pushScopeId("data-v-5ab7d175")
const _hoisted_1 = { class: "question-module" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "question-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_question = _resolveComponent("question")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.qList, (q, i) => {
        return (_openBlock(), _createBlock(_component_question, _mergeProps({
          key: q.id
        }, q, {
          seq: i+1,
          onReload: _ctx.reload
        }), null, 16, ["seq", "onReload"]))
      }), 128))
    ])
  ]))
})